import React, { useEffect, useState} from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import Home from './Home'
import Login from './Login'
import Register from './Register'
import Gallery from './Gallery'
import Profile from './Profile'
import FamilyTree from './FamilyTree'
import FamilyMembers from './FamilyMembers'
import FamilyMembersDeceased from './FamilyMembersDeceased'
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './queryClient';
import API_URL from './api/config';
import axios from 'axios';
import SearchPeople from './SearchPeople';
import SearchFamily from './SearchFamily';
import FamilySettings from './FamilySettings';
import FamilyPosts from './FamilyPosts';
import ProfileSettings from './ProfileSettings';
import FamilyRequests from './FamilyRequests';
import DeleteAccount from './DeleteAccount';
import DeactivateAccount from './DeactivateAccount';
import SignupTribe from './SignupTribe';
import SignupSubtribe from './SignupSubtribe';
import SignupSubgroup from './SignupSubgroup';
import SignupClan from './SignupClan';
import SignupTotem from './SignupTotem';
import SignupFamily from './SignupFamily';
import SignupCategory from './SignupCategory';
import SignupNoClan from './SignupNoClan';
import SignupNoTotem from './SignupNoTotem';
import SignupSelectFamily from './SignupSelectFamily';
import SignupSelectFamilyRedirect from './SignupSelectFamilyRedirect';
import ChatList from './ChatList';
import Chats from './Chats';
import FamilyTreeSpouse from './FamilyTreeSpouse';
import FamilyTreeSister from './FamilyTreeSister';
import EditPersonalInformation from './EditPersonalInformation';
import EditPersonalInfoSpouse from './EditPersonalInfoSpouse';
import EditPersonalInfoSister from './EditPersonalInfoSister';
import ForgotPassword from './ForgotPassword';
import ForgotPasswordReset from './ForgotPasswordReset';
import ForgotPasswordVerify from './ForgotPasswordVerify';
import VerifyOtpRegister from './VerifyOtpRegister';
import Welcome from './Welcome';
import FamilyEvents from './FamilyEvents';
import GalleryImages from './GelleryImages';
import ChildSafetyPolicy from './ChildSafetyPolicy';
import FamilyInfoUpdate from './FamilyInfoUpdate';
import FamilyInfoUpdateClan from './FamilyInfoUpdateClan';
import FamilyInfoUpdateClanAdd from './FamilyInfoUpdateClanAdd';
import FamilyInfoUpdateTotemAdd from './FamilyInfoUpdateTotemAdd';
import FamilySettingsEditClan from './FamilySettingsEditClan';
import FamilySettingsEditTotem from './FamilySettingsEditTotem';
import FamilySettingsEditClanAdd from './FamilySettingsEditClanAdd';
import FamilySettingsEditTotemAdd from './FamilySettingsEditTotemAdd';
import SignUpHusbandDetails from './SignUpHusbandDetails';
import PrintTree from './PrintTree';
import TreeSubscriptionNow from './TreeSubscriptionNow';
import TreeSubscription from './TreeSubscription';
import TreeSubscriptionSuccessful from './TreeSubscriptionSuccessful';
import TreeOrderPaymentSuccessful from './TreeOrderPaymentSuccessful';
import TreeOrderPayment from './TreeOrderPayment';
import TreeOrderPaymentNow from './TreeOrderPaymentNow';
import EditPersonalInfoSubscription from './EditPersonalInfoSubscription';
import TreeSubscriptionWeb from './TreeSubscriptionWeb';
import TreeSubscriptionWebNow from './TreeSubscriptionWebNow';
import TreeSubscriptionWebSuccessful from './TreeSubscriptionWebSuccessful';
import PrintTreeOrder from './PrintTreeOrder';
import PrintTreePreview from './PrintTreePreview';
import TreeOrderPaymentWeb from './TreeOrderPaymentWeb';
import TreeOrderPaymentNowWeb from './TreeOrderPaymentNowWeb';
import TreeOrderPaymentWebSuccessful from './TreeOrderPaymentWebSuccessful';
import FamilyRequestAccepted from './FamilyRequestAccepted';
import FamilyRequestAcceptedTree from './FamilyRequestAcceptedTree';
import Timeline from './Timeline';
import FamilySettingsTreeBackground from './FamilySettingsTreeBackground';
import VerifyInvitationInfoUpdate from './VerifyInvitationInfoUpdate';
import VerifyInvitationInfoConfirm from './VerifyInvitationInfoConfirm';
import VerifyInvitationReject from './VerifyInvitationReject';
import DeactivatedAccount from './DeactivatedAccount';
import NeedHelp from './NeedHelp';
import DeleteMyAccount from './DeleteMyAccount';
import DeleteMyAccountVerify from './DeleteMyAccountVerify';
import RegisterConfirmVerify from './RegisterConfirmVerify';
import RegisterConfirm from './RegisterConfirm';
import SignUpGender from './SignUpGender';

function App() {

  const [user, setUser] = useState(null);

    useEffect(() => {
        axios.get(`${API_URL}/verify-user-api`, { withCredentials: true })
            .then(res => {
                if (res.data.Status === "Success") {
                    setUser(res.data.user);
                } else {
                    setUser(null);
                }
            })
            .catch(err => {
                console.error("User not logged in", err);
                setUser(null);
            });
    }, []);

  return (

    // "homepage": "https://oret.africa/tree/",
    // basename="/tree/"
 

    
    <QueryClientProvider client={queryClient}>
    <BrowserRouter     basename="/tree/"  >
      <Routes>
       
        <Route path='/' element={<Login />} />
        <Route path='/home' element={<Home />} />
        <Route path='/register' element={<Register />} />
        <Route path='/gallery' element={<Gallery />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/family-tree' element={<FamilyTree />} />
        <Route path='/family-members' element={<FamilyMembers />} />
        <Route path='/family-members-deceased' element={<FamilyMembersDeceased />} />
        <Route path='/profile-settings' element={<ProfileSettings />} />
        <Route path='/search-people' element={<SearchPeople />} />
        <Route path='/search-family' element={<SearchFamily />} />
        <Route path='/family-settings' element={<FamilySettings />} />
        <Route path='/family-posts' element={<FamilyPosts />} />
        <Route path='/family-requests' element={<FamilyRequests />} />
        <Route path='/delete-account' element={<DeleteAccount />} />
        <Route path='/deactivate-account' element={<DeactivateAccount />} />
        <Route path='/sign-up-tribe' element={<SignupTribe />} />
        <Route path='/sign-up-subtribe' element={<SignupSubtribe />} />
        <Route path='/sign-up-subgroup' element={<SignupSubgroup />} />
        <Route path='/sign-up-clan' element={<SignupClan />} />
        <Route path='/sign-up-totem' element={<SignupTotem />} />
        <Route path='/sign-up-family' element={<SignupFamily />} />
        <Route path='/sign-up-category' element={<SignupCategory />} />
        <Route path='/sign-up-noclan' element={<SignupNoClan />} />
        <Route path='/sign-up-nototem' element={<SignupNoTotem />} />
        <Route path='/sign-up-select-family' element={<SignupSelectFamily />} />
        <Route path='/sign-up-select-family-redirect' element={<SignupSelectFamilyRedirect />} />
        <Route path='/chat-list' element={<ChatList />} />
        <Route path='/chat' element={<Chats />} />
        <Route path='/family-tree-spouse' element={<FamilyTreeSpouse/>} />
        <Route path='/family-tree-sister' element={<FamilyTreeSister/>} />
        <Route path='/edit-personal-information' element={<EditPersonalInformation/>} />
        <Route path='/edit-personal-info-spouse' element={<EditPersonalInfoSpouse/>} />
        <Route path='/edit-personal-info-sister' element={<EditPersonalInfoSister/>} />
        <Route path='/forgot-password' element={<ForgotPassword/>} />
        <Route path='/forgot-password-verify' element={<ForgotPasswordVerify/>} />
        <Route path='/forgot-password-reset' element={<ForgotPasswordReset/>} />
        <Route path='/verify-otp-register' element={<VerifyOtpRegister/>} />
        <Route path='/welcome' element={<Welcome/>} />
        <Route path='/family-events' element={<FamilyEvents/>} />
        <Route path='/gallery-images' element={<GalleryImages />} />
        <Route path='/child-safety-policy' element={<ChildSafetyPolicy />} />
        <Route path='/family-info-update' element={<FamilyInfoUpdate />} />
        <Route path='/family-info-update-clan' element={<FamilyInfoUpdateClan />} />
        <Route path='/family-info-update-clan-add' element={<FamilyInfoUpdateClanAdd />} />
        <Route path='/family-info-update-totem-add' element={<FamilyInfoUpdateTotemAdd />} />
        <Route path='/family-settings-edit-clan' element={<FamilySettingsEditClan />} />
        <Route path='/family-settings-edit-totem' element={<FamilySettingsEditTotem />} />
        <Route path='/family-settings-edit-clan-add' element={<FamilySettingsEditClanAdd />} />
        <Route path='/family-settings-edit-totem-add' element={<FamilySettingsEditTotemAdd />} />
        <Route path='/sign-up-husband-details' element={<SignUpHusbandDetails />} />
        <Route path='/print-tree' element={<PrintTree/>} />
        <Route path='/tree-subscription' element={<TreeSubscription/>} />
        <Route path='/tree-subscription-now' element={<TreeSubscriptionNow/>} />
        <Route path='/tree-subscription-successful' element={< TreeSubscriptionSuccessful/>} />
        <Route path='/tree-order-payment' element={< TreeOrderPayment/>} />
        <Route path='/tree-order-payment-now' element={< TreeOrderPaymentNow/>} />
        <Route path='/tree-order-payment-successful' element={< TreeOrderPaymentSuccessful/>} />
        
        <Route path='/edit-personal-info-subscription' element={<EditPersonalInfoSubscription />} />
        <Route path='/tree-subscription-web' element={<TreeSubscriptionWeb />} />
        <Route path='/tree-subscription-web-now' element={<TreeSubscriptionWebNow />} />
        <Route path='/tree-subscription-web-successful' element={<TreeSubscriptionWebSuccessful />} />
        <Route path='/print-tree-order' element={<PrintTreeOrder />} />
        <Route path='/print-tree-preview' element={<PrintTreePreview />} />
        <Route path='/tree-order-payment-web' element={< TreeOrderPaymentWeb/>} />
        <Route path='/tree-order-payment-now-web' element={< TreeOrderPaymentNowWeb />} />
        <Route path='/tree-order-payment-web-successful' element={< TreeOrderPaymentWebSuccessful/>} />

        <Route path='/family-request-accepted' element={< FamilyRequestAccepted/>} />
        <Route path='/family-request-accepted-tree' element={< FamilyRequestAcceptedTree/>} />
        <Route path='/timeline' element={< Timeline/>} />

        <Route path='/family-settings-tree-background' element={< FamilySettingsTreeBackground/>} />
        <Route path='/verify-invitation-info-update' element={< VerifyInvitationInfoUpdate/>} />
        <Route path='/verify-invitation-info-confirm' element={< VerifyInvitationInfoConfirm/>} />
        <Route path='/verify-invitation-reject' element={< VerifyInvitationReject/>} />
        <Route path='/deactivated-account' element={<DeactivatedAccount />} />
        <Route path='/need-help' element={<NeedHelp />} />
        <Route path='/delete-my-account' element={<DeleteMyAccount />} />
        <Route path='/delete-my-account-verify' element={<DeleteMyAccountVerify />} />
        <Route path='/register-confirm-verify' element={<RegisterConfirmVerify />} />
        <Route path='/register-confirm' element={<RegisterConfirm />} />
        <Route path='/sign-up-gender' element={<SignUpGender />} />
        
        
      </Routes>
    </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
